<template>
  <div class="article-page">
    <header class="article-header">
      <button
        type="button"
        class="back-btn"
        @click="$router.back()"
      >
        <van-icon name="arrow-left" />
      </button>
      <h1>
        {{ data.title }}
      </h1>
    </header>

    <main class="article-main">
      <section class="article-card">
        <div
          class="article-content"
          v-html="data.content"
        />
      </section>
    </main>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import { Icon } from 'vant';

Vue.use(Icon);

export default {
  name: 'Article',
  data() {
    return {
      data: {},
    };
  },
  created() {
    this.$parent.footer('user', false);
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      Fetch('/index/article_detail', {
        id: this.$router.history.current.params.code,
      }).then(res => {
        this.data = res.data;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.article-page {
  min-height: 100vh;
  padding-bottom: 18px;
  box-sizing: border-box;
  background: #f4f5fb;
  color: #061429;
}

.article-header {
  position: sticky;
  top: 0;
  z-index: 10;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7f8fd;
}

.article-header h1 {
  max-width: 72%;
  margin: 0;
  overflow: hidden;
  color: #202637;
  font-size: 14px;
  font-weight: 500;
  line-height: 58px;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.back-btn {
  position: absolute;
  left: 8px;
  top: 10px;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #071426;
  font-size: 22px;
}

.article-main {
  padding: 16px 16px 88px;
}

.article-card {
  overflow: hidden;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 8px 20px rgba(30, 45, 82, .045);
}

.article-content {
  min-height: 120px;
  padding: 18px 20px;
  box-sizing: border-box;
  color: #243049;
  font-size: 14px;
  line-height: 24px;
  word-break: break-word;
}

.article-content /deep/ p {
  margin: 0 0 12px;
}

.article-content /deep/ p:last-child {
  margin-bottom: 0;
}

.article-content /deep/ img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}

.article-content /deep/ a {
  color: #3775f4;
}
</style>
